import React, { useState } from "react";
import { Box, Typography, Avatar, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { styled } from "@mui/system";
import Button from "@mui/material/Button";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import { BorderColorOutlined, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTE_UPLOAD_FINAL_VIDEO } from "../../constants/routes";
import ProfileTabs from "../common/ProfileTabs";
import SeeviHeader from "../common/SeeviHeader";

const Avatar1 = styled(Avatar)({
  width: "51px",
  height: "51px",
});

const StyledTextBox = styled(Box)({
  fontSize: "16px",
  backgroundColor: "#ffffff",
  borderRadius: "10px",
  paddingTop: "16px",
  paddingBottom: "16px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: "400",
  color: "#1F2235",
  lineHeight: "1.5",
  marginLeft: "10px",
});

const RecordingTips = () => {
  const navigate = useNavigate();
  const prompts = useSelector((state: any) => state.app.prompts);
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel: any) => (eventL: any, isExpanded: any) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" bgcolor="#eeeeee" width="100%">
      <SeeviHeader />

      <ProfileTabs />

      <Box display="flex" alignItems="center" sx={{ backgroundColor: "#eeeeee" }} pl={1} pr={5} mb={3}>
        <Avatar1 src="/images/avatar-one.png" alt="Avatar" />
        <StyledTextBox px={2} mt={2}>
          <Box px={1}>
            <Typography className="custom-typography-video">
              2/3
              <br />
              Here are a few tips for you
            </Typography>
          </Box>
        </StyledTextBox>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        p={2}
        bgcolor="#ffffff"
        borderRadius="15px 15px 0px 0px"
        justifyContent="center"
        marginTop="2"
      >
        <Box>
          {/* Accordion 1 */}

          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            sx={{ bgcolor: expanded === "panel1" ? "#E6E4FE" : "transparent" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#756DE9" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography sx={{ fontSize: "16px", fontWeight: "500", color: "#756DE9" }}>
                Tips for your responses to prompts
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <Typography>1. Keep it simple and within 20 seconds.</Typography>
                <Typography>2. Be yourself.</Typography>
                <Typography>3. Avoid jargon.</Typography>
                <Typography>4. Practice before final recording.</Typography>
              </Box>
            </AccordionDetails>
          </Accordion>

          {/* Accordion 2 */}
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
            sx={{ bgcolor: expanded === "panel2" ? "#E6E4FE" : "transparent" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#756DE9" }} />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography sx={{ fontSize: "16px", fontWeight: "500", color: "#756DE9" }}>
                Tips for recording a good video
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <Typography>1. Be presentable as if were going for an interview.</Typography>
                <Typography>2. Find a quite spot.</Typography>
                <Typography>3. Ensure there is no noise from electronics or people.</Typography>
                <Typography>4. Ensure your space is well lit.</Typography>
                <Typography>5. De-clutter your space. Plain wall as background works well.</Typography>
                <Typography>6. Check your recordings and upload only when you are satisfied.</Typography>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
        <Box display="flex" mt={3}>
          <Typography sx={{ fontSize: "16px", fontWeight: "500", color: "#1F2235" }}>Selected Prompts</Typography>
        </Box>
        {Object.keys(prompts).map((key) => (
          <Box
            key={key}
            display="flex"
            justifyContent="space-between"
            mt={2}
            mb={1}
            sx={{
              padding: "10px 12px",
              border: "1px solid #E6E4FE",
              borderRadius: "10px",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: "700", color: "#1F2235" }}>{key}</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: "400", color: "#777777" }}>
                {prompts[key]?.question}
              </Typography>
            </Box>
            <Box
              onClick={() => navigate(-1)}
              sx={{
                cursor: "pointer",
              }}
            >
              <BorderColorOutlined sx={{ color: "#756DE9" }} />
            </Box>
          </Box>
        ))}

        {/* <Box
          display="flex"
          mt={5}
          mb={2}
          style={{ padding: "10px 12px", border: "1px solid #E6E4FE", borderRadius: "10px", flexDirection: "row" }}
        >
          <img src="images/lighting-vector.png" width="24px" height="24px" />
          <Typography sx={{ fontSize: "14px", fontWeight: "400", color: "#FF2300", marginLeft: "10px" }}>
            You have to go to your native camera to record and come back to the app to upload the video.{" "}
          </Typography>
        </Box> */}
      </Box>

      <Box display="flex" flexDirection="column" p={2} bgcolor="#ffffff">
        <Box display="flex">
          <Button
            sx={{
              backgroundColor: "white",
              borderRadius: "99px",
              fontSize: "16px",
              textTransform: "capitalize",
              width: "25%",
              color: "#000000",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
            variant="contained"
            size="small"
            style={{ padding: "15px 40px" }}
            className="w-100 mt-2 btn-pad"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          <Box flexGrow={1}></Box>
          <Button
            sx={{
              backgroundColor: "#756DE9",
              borderRadius: "99px",
              fontSize: "16px",
              textTransform: "capitalize",
              width: "70%",
              paddingY: "15px",
              paddingX: 0,
              "&:hover": {
                backgroundColor: "#756DE9",
              },
            }}
            variant="contained"
            size="small"
            className="w-100 mt-2 btn-pad"
            onClick={() => navigate(ROUTE_UPLOAD_FINAL_VIDEO)}
          >
            Next Up: Upload Video
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default RecordingTips;
